export default {
  combine: {
    view_report: "查看报告",
    add_login: "添加登录",
    add_function: "添加功能",
    add_page: "添加页面",
    add_role: "添加角色",
    add_user: "添加用户",
    edit_login: "编辑登录",
    edit_function: "编辑功能",
    edit_page: "编辑页面",
    edit_role: "编辑角色",
    edit_user: "编辑用户",
    edit_password: "编辑密码",
    delete_login: "删除登录",
    delete_function: "删除功能",
    delete_page: "删除页面",
    delete_role: "删除角色",
    delete_user: "删除用户",
    assign_functions: "分配功能",
    assign_roles: "分配角色",
    confirm_password: "确认密码",
    change_password: "更改密码",
    old_password: "旧密码",
    new_password: "新密码",
    account_status: "帐户状态",
    account_settings: "帐户设置",
    layout_settings: "布局设置",
    confirm_security_code: "确认安全代码",
    first_time_login : "首次登录",
    security_authentication: "安全认证",
    update_security: "更新安全性",
    disable_security: "禁用安全性",
    add_operator: "添加操作员",
    add_sub_account: "添加子帐户",
    edit_operator: "编辑操作员",
    edit_member: "编辑会员",
    approve_ticket: "批准工单",
    reject_ticket: "拒绝工单",
    add_bank_account: "添加银行帐户",
    edit_bank_account: "编辑银行帐户",
    reset_threshold: "重置阈值",
    adjust_balance: "调整余额",
    adjust_bank: "调整银行",
    adjust_member: "调整会员",
    configure_bank_setting: "配置银行设置",
    account_setup: "帐户设置",
    bank_transfer: "银行转账",
    ticket_audit: "工单审核",
    edit_bank_member: "编辑银行成员",
    edit_ibank_account: "编辑iBank帐户",
    edit_sub_account: "编辑子帐户",
    view_member: "查看会员",
    view_ticket: "查看工单",
    edit_ticket: "编辑工单",
    view_bank_account: "查看银行帐户",
    view_bank_member: "查看银行成员",
    view_ibank: "查看iBank",
    edit_ibank: "编辑iBank",
    download_package: "下载套餐",
    view_package: "查看套餐",
    edit_package: "编辑套餐",
    view_vip: "查看VIP",
    edit_vip: "编辑VIP",
    report: "报告",
    knock_off_promo: "撤销促销",
    add_member_promo: "添加会员促销",
    issue_bonus: "发放奖金",
    promo_package_download: "促销套餐下载",
    edit_authority: "编辑权限",
    reset_password: "重置密码",
    update_password: "更新密码",
    member_summary: "会员摘要",
    reset_password: "重置密码",
    issue_livestream_bonus: "发放直播奖金",
    member_reward: "会员奖励",
    reply_review: "回复评论",
    edit_affiliate: "编辑联盟",
    edit_bank_affiliate: "编辑银行联盟",
    approve_affiliate_ticket: "批准联盟工单",
    check_free_spin: "检查免费旋转",
    reject_affiliate_ticket: "拒绝联盟工单",
    wallet_adjust: "钱包调整",
    update_comm_package: "更新佣金套餐",
    approve_affiliate: "批准联盟",
    sub_acc_detail_affiliate: "子帐户详细信息联盟",
    get_tac: "获取TAC",
    add_coupon: "添加优惠券",
    update_coupon: "更新优惠券",
    issue_free_spin: "发放免费旋转",
    get_bank_tac: "获取银行TAC",
    issue_jackpot_scratch: "发放大奖刮刮卡",
    issue_angpao: "发放红包",
    update_global_setting: "更新全局设置",
    add_platform: "添加平台",
    edit_platform: "编辑平台",
    add_bank_group: "添加银行组",
    edit_bank_group: "编辑银行组",
    update_maintenance_schedule: "更新维护计划",
    add_withdrawal_limit: "添加提款限额",
    edit_withdrawal_limit: "编辑提款限额",
    add_campaign: "添加活动",
    edit_campaign: "编辑活动",
    add_promo_group: "添加促销组",
    edit_promo_group: "编辑促销组",
    reapprove_ticket: "重新批准工单",
    edit_vip_provider: "编辑VIP提供商",
    update_team: "更新团队",
    update_result: "更新结果",
    insert_result: "插入结果",
    bet_list: "投注列表",
    result_list: "结果列表",
    add_promo: "添加促销",
    raise_deposit_ticket: "提高存款工单",
    bank_adjust: "银行调整",
    promo_member_assign: "促销会员分配",
    bonus_issue: "发放奖金",
    update_vip: "更新VIP",
    update_member_profile: "更新会员资料",
    change_withdrawal_limit: "更改提款限额",
    change_bank_group: "更改银行组",
    change_promotion_group: "更改促销组",
    promotion_signup: "促销注册",
    edit_promo_signup: "编辑促销注册",
    update_provider_bet_limit: "更新提供商投注限额",
    update_bet_limit: "更新投注限额",
    update_member_bet_limit: "更新会员投注限额",
    edit_bank_group: "编辑银行组",
    edit_bank_account_group: "编辑银行账户组",
    redeposit_ticket: "重新存款工单",
    edit_promotion_group: "编辑促销组",
    edit_promotion_group_norm: "编辑促销组规范",
    get_inbox_list: "获取收件箱列表",
    view_result_changes_detail: "查看结果更改详情",
    edit_promotion_signup: "编辑促销注册",
    edit_bet_limit: "编辑投注限额",
    edit_provider_game_off: "编辑提供商游戏状态",
    edit_provider_rtp: "编辑提供商RTP",
    get_rebate: "获取返利",
    get_recent_deposit: "获取最近存款",
    add_survey: "添加调查",
    add_banner: "添加横幅",
    add_announcement_banner: "添加公告横幅",
    edit_announcement_banner: "编辑公告横幅",
    move_announcement_banner: "移动公告横幅",
    add_promotion_banner: "添加促销横幅",
    edit_promotion_banner: "编辑促销横幅",
    move_promotion_banner: "移动促销横幅",
    add_slide_banner: "添加幻灯片横幅",
    edit_slide_banner: "编辑幻灯片横幅",
    move_slide_banner: "移动幻灯片横幅",
    add_seo_page: "添加SEO页面",
    edit_seo_page: "编辑SEO页面",
    move_seo_page: "移动SEO页面",
    clear_outstanding: "清除未结金额",
    add_ip_whitelist: "添加IP白名单",
    edit_payment_option_provider: "编辑支付选项提供商",
    bonus_issue_bulk: "批量发放奖金",
    edit_bank_member_ewallet: "编辑银行成员(电子钱包)",
    redeposit: "重新存款",
    reject_approved_ticket: "拒绝已批准的工单",
    audit_ticket: "审核工单",
    review_ticket: "审查工单",
    edit_promotion_group_norm_seq: "编辑促销组规范顺序",
    edit_promo_provider_list: "编辑促销供应商列表",
    edit_promo_payment_option: "编辑促销付款选项",
    edit_campaign_provider_list: "编辑活动供应商列表",
    update_bank_provider_vip: "更新银行提供商VIP",
    update_global_setting_affiliate: "更新全局设置(联盟)",
    update_comm: "更新佣金",
    update_carry_over: "更新结转",
    update_settlement_type: "更新结算类型",
    review_affiliate_ticket: "审查联盟工单",
    audit_affiliate_ticket: "审核联盟工单",
    get_tac_affiliate: "获取TAC(联盟)",
    raise_deposit_ticket_gateway: "提出存款票务(网关)",
    member_details: "会员详情",
    direct_audit_ticket: "审核工单(直接)",
    get_rollback_detail: "获取回滚详情",
    get_reject_detail: "获取拒绝详情",
    manual_approve_ticket: "批准工单(手动)",
    add_label: "添加标签",
    edit_label: "编辑标签",
    set_bank_default_sender: "设置银行默认发件",
    rollback_processing_ticket: "回滚处理中工单",
    update_iframe_url: "更新内嵌框架网址",
    edit_exchange_rate: "编辑汇率",
    add_vip: "添加VIP",
    add_turnover_tier: "添加流水层",
    edit_turnover_tier: "编辑流水层",
    edit_promo_payment_gateway: "编辑促销支付网关",
    get_member_label_list: "会员标签列表",
    add_rescue_fund: "添加救援基金",
    get_custom_member_list: "定制会员列表",
    get_rescue_fund_provider: "获取救援基金供应商",
    add_game_exclude: "添加排除游戏",
    log_repulling: "日志重拉",
  },
  authority: {
    account: "帐户",
    ticket: "工单",
    bank: "银行",
    promotion: "促销",
    vip: "VIP",
    vopr: "查看操作员",
    eopr: "编辑操作员",
    vmb: "查看会员",
    vtix: "查看工单",
    etix: "编辑工单",
    vbkacc: "查看银行帐户",
    ebkacc: "编辑银行帐户",
    vbkmb: "查看银行成员",
    ebkmb: "编辑银行成员",
    vibk: "查看iBank",
    eibk: "编辑iBank",
    dlpck: "下载套餐",
    vpck: "查看套餐",
    epck: "编辑套餐",
    vrescuefund: "查看救援基金",
    erescuefund: "编辑救援基金",
    vvip: "查看VIP",
    evip: "编辑VIP",
    log: "日志",
    rpt: "报告",
    affiliate: "联盟",
    setup: "设置",
    providerwinlose: "提供商盈亏",
    export_excel: "导出Excel",
    cms: "内容管理系统"
  },
  short: {
    provider_status: "奖励状态",
    own_status: "运营商状态",
    deposit_amount: "存款金额",
    base_amount: "基础金额",
    bonus_amount: "奖金金额",
    target_amount: "目标金额",
    accumulate_win: "帐户赢得",
    accumulate_turnover: "帐户输给",
    accumulate_amount: "帐户金额",
    knockoff_by: "击倒者",
    knockoff_date: "击倒日期",
    incoming_amount_threshold: "收入金额阈值",
    accumulate_incoming_amount: "累积收入金额",
    incoming_frequency_threshold: "收入金额频率",
    accumulate_incoming_frequency: "累积收入频率",
    outgoing_amount_threshold: "出款金额阈值",
    accumulate_outgoing_amount: "累积出款金额",
    outgoing_frequency_threshold: "出款金额频率",
    accumulate_outgoing_frequency: "累积出款频率",
    incoming_threshold: "内部金额阈值",
    incoming_frequency: "内部金额频率",
    outgoing_threshold: "出款金额阈值",
    outgoing_frequency: "出款金额频率",
    account_balance: "帐户余额",
    promotion_id: "玩家ID",
    promotion_name: "玩家姓名",
    claim_type: "领取类型",
    min_deposit: "最小存款",
    bonus_rate: "奖金比率",
    max_bonus: "最小奖金",
    rollover: "流水要求",
    criteria: "条件",
    withhold_bonus: "奖金",
    withhold_amount: "奖励金额",
    max_withdraw_amount: "最大提款金额",
    start_date: "开始日期",
    end_date: "结束日期",
    start_time: "开始时间",
    end_time: "结束时间",
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期日",
    status: "状态",
    bonus_rate_percent: "奖金比例(%)",
    referee_count_confirm: "推荐人计数",
    provider_list: "供应商列表",
    valid_turnover: "有效投注额",
    deposit_amount: "存款金额",
    deposit_count: "存款次数",
    withdrawal_amount: "取款金额",
    withdrawal_count: "取款次数",
    bonus_amount: "奖金金额",
    adjustment_amount: "调整金额",
    referee_count: "推荐会员数",
    signup_count: "注册会员数",
    verified_count: "实名认证计数",
    active_member: "活跃会员",
    ftd_count: "首次存款次数",
    ftd_amount: "首次存款金额",
    working_date: "工作日期",
    bet_count: "投注次数",
    recipient_bank_id: "目标银行ID",
    recipient_bank_acc_no: "目标银行账号",
    recipient_bank_acc_holder: "目标银行账号持有人",
    sender_bank: "发起银行",
    sender_bank_acc_no: "发起银行账号",
    sender_bank_acc_holder: "发起银行账号持有人",
    unique_login_count: "独特登录次数",
    unique_withdrawal_count: "独特出款次数",
    second_deposit_count: "第二次存款次数",
    reject_date: "拒绝日期",
    processing_date: "处理日期",
    rescue_id: "救援ID",
    rescue_name: "救援名称",
    rescue_cycle: "救援周期",
    min_lose: "最小损失",
    rescue_rate: "救援比率",
    max_payout: "最大支付",
    actual_amount: "实际金额",
    rounded_amount: "四舍五入金额",
    total_winlose: "总赢输",
  },
  ok: "确定",
  cancel: "取消",
  apply: "应用",
  login: "登录",
  logout: "登出",
  home: "主页",
  away: "离开",
  add: "添加",
  edit: "编辑",
  delete: "删除",
  refresh: "刷新",
  assign: "分配",
  action: "操作",
  id: "编号",
  name: "名称",
  all: "全部",
  search: "搜索",
  remove: "移除",
  save: "保存",
  load: "加载",
  account: "帐户",
  settings: "设置",
  on: "开启",
  off: "关闭",
  new: "新建",
  clear: "清空",
  system: "系统",
  functions: "功能",
  pages: "页面",
  roles: "角色",
  users: "用户",
  username: "用户名",
  password: "密码",
  created_on: "创建日期",
  active: "活跃",
  disabled: "已禁用",
  blocked: "已封锁",
  suspended: "已暂停",
  page_size: "页面大小",
  no_data: "暂无数据",
  status: "状态",
  login_attempt: "登录尝试",
  user_roles: "角色",
  layout: "布局",
  mustang: "EpicPH后台",
  fullname: "全名",
  view: "查看",
  moreinfo: "更多信息",
  result: "结果",
  success: "成功",
  version: "版本",
  ipaddress: "IP地址",
  // close: "关闭",
  close: "冻结",
  back: "返回",
  show: "显示",
  list: "列表",
  login_id: "登录ID",
  login_name: "登录名",
  filter: "过滤器",
  ascending: "升序",
  descending: "降序",
  logs: "日志",
  action_log: "操作日志",
  date_time: "日期时间",
  status_desc: "状态描述",
  ip_address: "IP地址",
  domain_name: "域名",
  browser_agent: "浏览器代理",
  action_by: "操作人",
  target_id: "目标ID",
  target_action: "目标操作",
  details: "详情",
  key: "键",
  value: "键值",
  sort: "排序",
  next: "下一页",
  from: "从",
  to: "到",
  type: "类型",
  criteria: "条件",
  search_input: "搜索输入",
  log: "日志",
  detail_id: "详细ID",
  action_name: "操作名称",
  reports: "报告",
  report: "报告",
  sample_rpt: "样本报告",
  security_tag: "安全标签",
  security_code: "安全代码",
  submit: "提交",
  disable: "禁用",
  operators: "操作员",
  members: "会员",
  account_id: "帐户ID",
  parent_id: "上级ID",
  confirm_password: "确认密码",
  self_operate: "自主操作",
  vip_mode: "VIP模式",
  full_name: "全名",
  contact_phone: "联系电话",
  contact_email: "联系电子邮件",
  dashboard: "仪表板",
  sub_account: "子帐户",
  subaccount: "子帐户",
  authority_option: "权限选项",
  tickets: "门票",
  banks: "银行",
  vip_level: "VIP级别",
  login_ip : "登录IP",
  block: "封锁",
  profile_id: "档案ID",
  // suspend: "暂停",
  suspend: "禁提",
  dob: "出生日期",
  mail_address: "邮寄地址",
  deposit: "存款",
  withdrawal: "取款",
  rejected: "拒绝",
  processed: "已处理",
  pending: "待处理",
  member: "会员",
  amount: "金额",
  bank_acc_no: "银行帐号",
  deposit_date: "存款日期",
  deposit_method: "存款方式",
  approve: "批准",
  reject: "拒绝",
  remark: "备注",
  ticket_detail: "门票详细信息",
  promo: "促销",
  package: "套餐",
  created_date: "创建日期",
  currency: "货币",
  bank_acc_holder: "银行帐户持有人",
  ref_no: "参考号",
  vip: "VIP",
  vip_criteria: "VIP标准",
  requirement: "要求",
  level_1: "一级",
  level_1_name: "一级名称",
  level_1_requirement: "一级要求",
  level_1_multp: "一级乘数",
  level_2: "二级",
  level_2_name: "二级名称",
  level_2_requirement: "二级要求",
  level_2_multp: "二级乘数",
  level_3: "三级",
  level_3_name: "三级名称",
  level_3_requirement: "三级要求",
  level_3_multp: "三级乘数",
  level_4: "四级",
  level_4_name: "四级名称",
  level_4_requirement: "四级要求",
  level_4_multp: "四级乘数",
  level_5: "五级",
  level_5_name: "五级名称",
  level_5_requirement: "五级要求",
  level_5_multp: "五级乘数",
  level_6: "六级",
  level_6_name: "六级名称",
  level_6_requirement: "六级要求",
  level_6_multp: "六级乘数",
  level_7: "七级",
  level_7_name: "七级名称",
  level_7_requirement: "七级要求",
  level_7_multp: "七级乘数",
  modified_date: "修改日期",
  modified_by: "修改者",
  bank_member: "银行成员",
  bank_operator: "银行操作员",
  bank_name: "银行名称",
  bank_acc_type: "银行帐户类型",
  login_user: "登录用户",
  login_pwd: "登录密码",
  account_balance: "帐户余额",
  threshold: "阈值",
  incoming: "收入",
  outgoing: "支出",
  frequency: "频率",
  reset_threshold: "重置阈值",
  adjust_balance: "调整余额",
  banking_mode: "银行模式",
  min_deposit: "最低存款",
  min_withdrawal: "最低取款",
  bank_from: "从银行",
  bank_to: "到银行",
  attachment: "附件",
  sender_bank: "发件银行",
  sender_bank_acc_no: "发件银行帐号",
  sender_bank_acc_holder: "发件银行帐户持有人",
  audit: "审计",
  log_id: "日志ID",
  action_status: "操作状态",
  action_date: "操作日期",
  promotion: "促销",
  promotion_package: "促销套餐",
  promotion_account: "促销帐户",
  promo_id: "促销ID",
  promo_name: "促销名称",
  promo_desc: "促销描述",
  packages: "套餐 | 套餐",
  package_id: "套餐ID",
  package_name: "套餐名称",
  claim_type: "领取类型",
  bonus_rate: "奖金比率",
  max_bonus: "最大奖金",
  rollover: "流水倍数",
  start_date: "开始日期",
  end_date: "结束日期",
  provider_status: "提供商状态",
  own_status: "自身状态",
  package_own_status: "套餐自身状态",
  ibank: "iBank",
  ibank_account: "iBank帐户",
  ibank_acc_status: "iBank帐户状态",
  download: "下载",
  min_balance: "最低余额",
  parent: "上级",
  adj_amount: "调整金额",
  promotion_member: "促销会员",
  on_going: "进行中",
  knock_off: "解除",
  deposit_amount: "存款金额",
  base_amount: "基础金额",
  bonus_amount: "奖金金额",
  bonus_id: "奖金ID",
  target_amount: "目标金额",
  claim_date: "领取日期",
  accumulate_win: "累积赢",
  accumulate_turnover: "累积流水",
  knockoff_by: "解锁者",
  knockoff_date: "解锁日期",
  promo: "促销",
  package: "套餐",
  bonus: "奖金",
  member_log: "会员日志",
  bonus_log: "奖金日志",
  transfer_log: "转账日志",
  member_id: "会员ID",
  before_balance: "交易前余额",
  transfer_amount: "转账金额",
  after_balance: "交易后余额",
  created_by: "创建者",
  bonus_name: "奖金名称",
  bonus_desc: "奖金描述",
  bonus_type: "奖金类型",
  add_promo: "添加促销",
  bonus_value: "奖金数值",
  attach_promo: "附加促销",
  issue_bonus: "发放奖金",
  daily_statement: "每日报表",
  working_date: "工作日期",
  opening_balance: "初始余额",
  turnover: "流水",
  valid_turnover: "有效流水",
  winlose: "赢输",
  withdrawal_amount: "取款金额",
  closing_balance: "结算余额",
  sub_total: "小计",
  grand_total: "总计",
  daily_winlose: "每日赢输",
  game_result_slots: "游戏结果(老虎机)",
  game_result_livecasino: "游戏结果(真人娱乐)",
  game_result_rebate: "游戏结果(返点)",
  game_result_sportsbook: "游戏结果(体育博彩)",
  game_result_cockfight: "游戏结果(斗鸡)",
  game_result_rescue: "游戏结果(救援)",
  game_result: "游戏结果",
  bet_count: "投注次数",
  result_id: "结果ID",
  bet_time: "投注时间",
  payout: "赔付",
  game_type: "游戏类型",
  game_name: "游戏名称",
  game_provider: "游戏提供商",
  loyalty_point_multp: "忠诚积分倍数",
  vip_detail: "VIP详情",
  reset: "重置",
  mode: "模式",
  balance: "余额",
  min_bal_knock_off_promo: "最低余额(自动解锁促销)",
  social_account: "社交账号",
  wechat: "微信",
  skype: "Skype",
  line: "Line",
  telegram: "Telegram",
  whatsapp: "Whatsapp",
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "Tiktok",
  qq: "QQ",
  twitter: "Twitter",
  viber: "Viber",
  future1: "未来1",
  future2: "未来2",
  future3: "未来3",
  login_log: "登录日志",
  failed: "失败",
  web: "网页",
  mobile: "移动设备",
  platform: "平台",
  bank_statement: "银行对账单",
  transfer_date: "转账日期",
  detail: "详情",
  date: "日期",
  transfer_list: "转账列表",
  credit: "存款",
  debit: "取款",
  month: "月份",
  unblock: "解锁",
  unblock_member: "解锁会员",
  unblock_operator: "解锁操作员",
  after_balance: "交易后余额",
  referrer_id: "推荐人ID",
  referrer_code: "推荐人代码",
  referral_code: "推荐代码",
  bonus_and_adjustment: "奖金和调整",
  adjustment: "调整",
  incoming_amount_threshold: "收入金额阈值",
  incoming_frequency_threshold: "收入频率阈值",
  outgoing_amount_threshold: "支出金额阈值",
  outgoing_frequency_threshold: "支出频率阈值",
  settle: "结算",
  knock_off_by: "解锁者",
  knock_off_date: "解锁日期",
  accumulate_amount: "累积金额",
  deposit_amount: "存款金额",
  total_turnover: "总流水",
  total_winlose: "总赢输",
  total_deposit: "总存款",
  total_withdrawal: "总取款",
  total_member: "总会员",
  active_player: "活跃玩家",
  top_winner: "最高赢家",
  top_loser: "最高输家",
  winner: "赢家",
  loser: "输家",
  deposit_count: "存款次数",
  withdrawal_count: "取款次数",
  bet_count: "投注次数",
  summary: "汇总",
  alert: "警告",
  incoming_threshold: "存款阈值",
  incoming_frequency: "存款频率",
  outgoing_threshold: "取款阈值",
  outgoing_frequency: "取款频率",
  reset_password: "重置密码",
  authority_option: "权限选项",
  transfer: "转账",
  company_bank: "公司银行",
  company_bank_acc_no: "公司银行账号",
  company_bank_acc_holder: "公司银行账户持有人",
  registered_member: "注册会员",
  registered_member: "注册会员",
  promotion_report: "促销报告",
  deposited_member: "存款会员",
  referred_member: "推荐会员",
  validated_on: "验证日期",
  referrer: "推荐人",
  issue_livestream_bonus: "发放直播奖金",
  livestream_bonus: "直播奖金",
  first_deposit: "首次存款",
  first_deposit_at: "首次存款时间",
  nickname: "昵称",
  member_nickname: "会员昵称",
  free_spin: "免费旋转",
  reward: "奖励",
  in_game: "游戏内",
  inbox: "收件箱",
  manual_bonus: "手动奖金",
  review: "评论 | 评论",
  review_list: "评论列表",
  review_detail: "评论详情",
  reply_review: "回复评论",
  comment: "评论",
  reply: "回复",
  recipient_no: "收件人编号",
  question : "问题",
  rating: "评分",
  message: "消息",
  message_blast: "群发消息",
  text: "文本",
  content: "内容",
  image: "图像",
  send: "发送",
  monthly_rating: "月度评分",
  affiliate: "联盟",
  affiliate_list: "联盟列表",
  approve_affiliate: "批准联盟",
  affiliate_code: "联盟代码",
  approved_by: "批准者",
  approved_date: "批准日期",
  bank_affiliate: "银行联盟",
  bank_id: "银行ID",
  ticket_affiliate: "票务联盟",
  ticket_detail_affiliate: "票务联盟详情",
  pending_application: "待处理申请",
  withdrawal_request: "取款请求",
  unblock_affiliate: "解锁联盟",
  check_free_spin: "检查免费旋转",
  member_contribution: "会员贡献",
  wallet_adjust: "钱包调整",
  comm_package: "佣金套餐",
  affiliate_id: "联盟ID",
  update_comm_package: "更新佣金套餐",
  sub_account_detail: "子账户详情",
  comm_log: "佣金日志",
  earning_breakdown: "收益明细",
  daily_winlose_member: "会员每日赢输",
  total_revenue: "总收入",
  earning_amount: "收益金额",
  player_id: "玩家ID",
  daily_winlose_affiliate: "每日赢输(联盟)",
  comm_package_old: "旧佣金套餐",
  comm_package_new: "新佣金套餐",
  export_excel: "导出Excel",
  get_tac: "获取TAC",
  tac_code: "TAC代码",
  expiry_date: "过期日期",
  inactive: "无效",
  player_list: "玩家列表",
  last_deposit_date: "最后存款日期",
  last_deposit_amount: "最后存款金额",
  never_deposited: "从未存款",
  coupon: "优惠券",
  allocated: "已分配",
  claimed: "已索取",
  approved: "已批准",
  min_deposit: "最低存款",
  bonus_rate: "奖金比率",
  coupon_code: "优惠券代码",
  coupon_name: "优惠券名称",
  coupon_quota: "优惠券配额",
  current_allocated: "当前已分配",
  new_allocated: "新的已分配",
  update : "更新",
  coupon_own_status: "优惠券拥有状态",
  tac_validated: "TAC验证",
  copy: "复制",
  deposit_amount: "存款金额",
  bonus_rate_percent : "奖金比率(%)",
  coupon_desc: "优惠券描述",
  both: "两者",
  issue_free_spin: "发放免费旋转",
  game: "游戏",
  free_spin_count: "免费旋转次数",
  max_win_amount: "最大赢取金额",
  utm_list: "UTM列表",
  search_by_member: "按会员搜索",
  source: "来源",
  medium: "媒体",
  campaign: "活动",
  term: "关键词",
  youtube: "YouTube",
  livechat: "在线聊天",
  deposited: "已存款",
  search_by_id: "按ID搜索",
  get_bank_tac: "获取银行TAC",
  bank_statement_daily: "银行对账单(每日)",
  transfer_type: "转账类型",
  issue_jackpot_scratch: "发放彩票刮刮卡",
  quantity: "数量",
  audit_freebies_list: "审计免费赠品列表",
  acknowledge: "确认",
  submit_acknowledgement: "提交确认",
  blog: "博客",
  is_ack: "是否确认",
  yes: "是",
  no: "否",
  audit_rescue_fund_list: "审计救援基金列表",
  issue_angpao: "发放红包",
  global_setting: "全局设置",
  signup_ip: "注册IP",
  last_login_ip: "上次登录IP",
  last_login_time: "上次登录时间",
  link: "链接",
  is_default: "是否默认",
  is_public: "是否公开",
  bank_group: "银行组",
  set_default: "设为默认",
  group_id: "组ID",
  group_name: "组名",
  provider_maintenance: "供应商维护",
  provider_code: "供应商代码",
  provider_name: "供应商名称",
  withdrawal_limit: "取款限额",
  limit_id: "限额ID",
  limit_name: "限额名称",
  daily_amount: "每日金额",
  daily_frequency: "每日频率",
  promotion_id: "促销ID",
  promotion_name: "促销名称",
  withhold_bonus: "保留奖金",
  withhold_amount: "保留金额",
  withhold_amt: "保留金额",
  max_withdraw_amt: "最大提款金额",
  max_withdraw_amount: "最大提款金额",
  monday: "星期一",
  tuesday: "星期二",
  wednesday: "星期三",
  thursday: "星期四",
  friday: "星期五",
  saturday: "星期六",
  sunday: "星期日",
  start_time: "开始时间",
  end_time: "结束时间",
  day: "天 | 天数",
  coupon_status: "优惠券状态",
  campaign_id: "活动ID",
  campaign_name: "活动名称",
  prerequisite_promo_id: "先决条件促销ID",
  promotion_group: "促销组",
  referral_status: "推荐状态",
  referee_count_confirm: "确认被推荐人数",
  referee_list: "推荐人列表",
  account_verified: "账户已验证",
  verified_date: "验证日期",
  ticket_list: "票务列表",
  pending_ticket: "待处理票务",
  reapprove: "重新批准",
  vip_id: "VIP ID",
  vip_name: "VIP名称",
  self_rebate_rate: "自返点率",
  downline_rebate_rate: "下线返点率",
  provider: "供应商",
  mini_game: "迷你游戏",
  team_log: "团队日志",
  result_log: "结果日志",
  match_id: "比赛ID",
  home_team: "主队",
  away_team: "客队",
  home_team_new: "主队新",
  away_team_new: "客队新",
  updated_by: "更新者",
  updated_on: "更新日期",
  home_score: "主队得分",
  away_score: "客队得分",
  home_score_new: "主队得分新",
  away_score_new: "客队得分新",
  team: "球队",
  match_time: "比赛时间",
  match_round: "比赛轮次",
  home_group: "主队组",
  away_group: "客队组",
  match: "比赛",
  match_status: "比赛状态",
  insert: "插入",
  pin: "个人识别码",
  bet_list: "投注列表",
  result_list: "结果列表",
  bet_id: "投注ID",
  bet_home: "主队投注",
  bet_away: "客队投注",
  bet_on: "投注方向",
  max_withdrawal: "最大提款额",
  max_withdrawal_count: "最大提款次数",
  min_balance: "最低余额",
  min_deposit: "最低存款",
  min_withdrawal: "最低提款",
  raise_deposit_ticket: "提出存款票务",
  method: "方法",
  one_time_depositor: "首次存款者",
  current_month_non_depositor: "本月未存款者",
  current_month_no_login: "本月未登录",
  ticket_date: "票务日期",
  ftd_amount: "首存金额",
  bonus_issue: "奖金发放",
  promotion_summary: "促销总结",
  claim_frequency: "领取频率",
  provider_list: "供应商列表",
  platform_winlose: "平台输赢",
  adjustment_amount: "调整金额",
  referee_count: "推荐人数",
  category: "类别",
  update_vip: "更新VIP",
  update_member_profile: "更新会员资料",
  promotion_signup: "促销报名",
  provider_bet_limit: "供应商投注限制",
  update_bet_limit: "更新投注限制",
  update_member_bet_limit: "更新会员投注限制",
  bet_limit: "投注限制",
  sports_game: "体育/游戏",
  match_time: "比赛时间",
  league_name: "联赛名称",
  home_team_name: "主队名称",
  away_team_name: "客队名称",
  home_score: "主队得分",
  away_score: "客队得分",
  wl_status: "输赢状态",
  available_bank_account: "可用银行账户",
  group_bank_account: "银行账户组",
  edit_bank_group: "编辑银行组",
  edit_bank_account_group: "编辑银行账户组",
  redeposit: "重新存款",
  upline: "上线",
  downline: "下线",
  available_promotion: "可用促销",
  group_promotion: "促销组",
  edit_promotion_group: "编辑促销组",
  edit_promotion_group_norm: "编辑促销组规范",
  balance_before: "余额变动前",
  balance_after: "余额变动后",
  signup_count: "注册人数",
  verified_count: "验证人数",
  active_member: "活跃会员",
  ftd_count: "首存人数",
  daily_summary_company: "每日总结(公司)",
  daily_summary_member: "每日总结(会员)",
  adjustment_list: "调整列表",
  bonus_list: "奖金列表",
  ltd_date: "LTD日期",
  promotion_signup_unused: "未使用促销报名",
  promotion_signup_ongoing: "进行中的促销报名",
  adjustment_log: "调整日志",
  get_inbox: "收件箱",
  is_claimed: "已领取",
  mix_parlay: "混合串联",
  event: "事件",
  result_changes_log: "结果变更日志",
  view_detail: "查看详细信息",
  total_referee: "总推荐人数",
  verified_signup: "已验证/报名",
  ftd: "首存",
  raw_msg: "原始消息",
  unselect_all: "取消全选",
  select_all: "全选",
  edit_bet_limit: "编辑投注限制",
  provider_game_off: "供应商游戏关闭",
  game_id : "游戏ID",
  game_list: "游戏列表",
  off_list: "关闭列表",
  provider_rtp: "供应商RTP",
  rtp: "RTP",
  signup_date: "注册日期",
  free_credit: "免费信用",
  get_rebate: "获取返点",
  downline_rebate: "下线返点",
  game_rebate: "游戏返点",
  rebate: "返点",
  ftd_date: "首存日期",
  provider_winlose_company: "供应商输赢(公司)",
  report_promotion: "报告(促销)",
  already_hit: "已达成",
  ongoing: "进行中",
  members_export: "会员(导出)",
  get_recent_deposit: "获取最近存款",
  recent_deposit: "最近存款",
  survey_list: "调查列表",
  modified_on: "修改日期",
  cms: "内容管理系统",
  announcement_banner: "公告横幅",
  promotion_banner: "促销横幅",
  slide_banner: "幻灯片横幅",
  seo_page: "SEO 页面",
  en_title: "标题(英文)",
  fil_title: "标题(菲律宾语)",
  en_img: "图片(英文)",
  fil_img: "图片(菲律宾语)",
  en_body: "正文(英文)",
  fil_body: "正文(菲律宾语)",
  before_login: "登录前",
  after_login: "登录后",
  en: "英文",
  fil: "菲律宾语",
  move_up: "上移",
  move_down: "下移",
  banner_type: "横幅类型",
  default_order: "默认顺序",
  item_order: "项目顺序",
  title: "标题",
  banner_id: "横幅ID",
  order: "顺序",
  body: "正文",
  en_image: "图片(英文)",
  fil_image: "图片(菲律宾语)",
  move: "移动",
  en_img_desktop: "桌面图片(英文)",
  fil_img_desktop: "桌面图片(菲律宾语)",
  en_img_mobile: "移动图片(英文)",
  fil_img_mobile: "移动图片(菲律宾语)",
  login_required: "需要登录",
  new_window_tab: "新窗口/选项卡",
  current_page: "当前页面",
  target: "目标",
  alt: "替代文本",
  href: "超链接",
  image_desktop: "桌面图片",
  image_mobile: "移动图片",
  en_alt: "替代文本(英文)",
  fil_alt: "替代文本(菲律宾语)",
  en_href: "超链接(英文)",
  fil_href: "超链接(菲律宾语)",
  en_image_desktop: "桌面图片(英文)",
  active_period: "有效期",
  en_page: "页面(英文)",
  fil_page: "页面(菲律宾语)",
  en_item: "项目(英文)",
  fil_item: "项目(菲律宾语)",
  meta_title: "元标题",
  meta_keywords: "元关键字",
  meta_url: "元URL",
  meta_canonical: "元规范",
  meta_author: "元作者",
  meta_publisher: "元发布者",
  meta_lang: "元语言",
  meta_desc: "元描述",
  meta_image: "元图片",
  page: "页面",
  item: "项目",
  remove_desktop_image: "删除桌面图片",
  remove_mobile_image: "删除移动图片",
  page_name: "页面名称",
  login_date: "登录日期",
  ftd_amount_min: "最低首存金额",
  ftd_amount_max: "最高首存金额",
  manual_bonus_only: "仅手动奖金",
  settled_time: "结算时间",
  fl_provider_code: "首次启动供应商",
  fl_game_id: "首次启动游戏ID",
  fl_game_name: "首次启动游戏名称",
  no_deposit: "无需存款",
  no_login: "无需登录",
  top_deposit: "最高存款",
  top_withdrawal: "最高提款",
  top_rebate_self: "最高自我回扣",
  top_rebate_downline: "最高下线回扣",
  top_promotion: "最高促销",
  outstanding_balance: "未结算余额",
  last_update_time: "最后更新时间",
  last_validated: "最后验证",
  trace: "追踪",
  trace_outstanding: "追踪未结算",
  outstanding: "未结算",
  clear_outstanding: "清除未结算",
  meta_image_url: "元图片URL",
  member_bonus: "会员奖金",
  delete_after_bonus: "奖金后删除",
  crm_list: "客户关系管理列表",
  last_login_date: "最后登录日期",
  advance_search: "高级搜索",
  deposit_count_from: "存款计数从",
  deposit_count_to: "存款计数至",
  deposit_amount_from: "存款金额从",
  deposit_amount_to: "存款金额至",
  min_day_no_login: "最低不登录天数",
  min_day_no_deposit: "最低不存款天数",
  last_login: "最后登录",
  last_deposit: "最后存款",
  phone: "电话",
  email: "电子邮件",
  ip_whitelist: "IP白名单",
  ip: "IP",
  payment_option: "付款选项",
  payment_mode: "付款方式",
  payment_desc: "付款说明",
  edit_provider: "编辑供应商",
  group: "组",
  success: "成功",
  failed: "失败 ",
  failed_members: "失败的会员 ",
  bank_member_ewallet: "银行会员(电子钱包)",
  ticket_list_auto_withdrawal: "票证列表(自动提款)",
  processing: "处理中",
  recipient_bank_id: "收款银行ID",
  recipient_bank_acc_no: "收款银行帐号",
  sender_bank_acc_no: "发送方银行帐号",
  ticket_auto_withdrawal_log: "票证日志(自动提款)",
  resubmit_ticket: "重新提交票证",
  ticket_export: "工单(导出)",
  export_deposit: "导出存款",
  export_withdrawal: "导出提款",
  processed_rejected: "已处理(拒绝)",
  channel: "渠道",
  influencer: "影响者",
  ticket_id: "工单ID",
  recommend: "推荐",
  sequence: "顺序",
  progress: "进度",
  statement_info: "报表信息",
  member_info: "会员信息",
  slots: "老虎机",
  livecasino: "真人娱乐",
  sportsbook: "体育博彩",
  cockfight: "斗鸡",
  member_list: "会员列表",
  member_details: "会员详情",
  operator: "操作员",
  game_balance: "游戏余额",
  claim_limit: "领取限制",
  max_withdraw_multiple: "最大提款乘数",
  login_count: "登入次数",
  ip_info: "IP信息",
  payment_gateway: "支付网关",
  min_limit: "最小限额",
  max_limit: "最大限额",
  unique_member_count: "独特会员数",
  total: "总数",
  success_rate: "成功率",
  rebate_summary: "返利总结",
  rebate_summary_v2: "返利总结v2",
  self: "自己",
  system_balance: "系统余额",
  rejected_onload: "拒绝(装载)",
  onload: "装载",
  no_bonus: "没奖金",
  review_audit_ticket: "审查和审核票务",
  audit_ticket: "审核工单",
  review_ticket: "审查工单",
  edit_promotion_group_norm_seq: "编辑促销组规范顺序",
  promotion_signup_winlose: "促销报名输赢",
  promotion_signup_winlose_detail: "促销报名输赢详情",
  edit_promo_provider_list: "编辑促销供应商列表",
  edit_promo_payment_option: "编辑促销付款选项",
  edit_campaign_provider_list: "编辑活动供应商列表",

  bank_provider: "银行提供商",
  provider_group: "提供商组",
  update_bank_provider_vip: "更新银行提供商VIP",
  member_custom_vip: "会员定制VIP",
  unlock: "解锁",
  signup_bonus: "注册奖金",
  platform_fee: "平台费",
  update_global_setting_affiliate: "更新全局设置(联盟)",
  global_setting_affiliate: "全局设置(联盟)",
  settlement_type: "结算类型",
  carry_over: "结转",
  comm_sports: "佣金(体育博彩)",
  comm_slots: "佣金(老虎机)",
  comm_livecasino: "佣金(真人娱乐)",
  comm_cockfight: "佣金(斗鸡)",
  comm_others: "佣金(其他)",
  update_comm: "更新佣金",
  update_carry_over: "更新结转",
  update_settlement_type: "更新结算类型",
  ewallet: "电子钱包",
  withdrawal_list: "提款列表",
  review_audit_ticket_affiliate: "审查和审核票务(联盟)",
  daily_withdrawal: "每日提款",
  adjustment_log_affiliate: "调整日志(联盟)",
  daily_statement_affiliate: "每日报表(联盟)",
  settlement_log_affiliate: "结算日志(联盟)",
  adjustment_list_affiliate: "调整列表(联盟)",
  settlement_list_affiliate: "结算列表(联盟)",
  earning: "收益",
  settlement_account_id: "结算帐户ID",
  settlement_date: "结算日",
  earning_total: "总收益",
  cost_total: "总花费",
  pnl: "收益与损失",
  deposit_bonus: "存款奖金",
  wl_sports: "输赢(体育博彩)",
  wl_slots: "输赢(老虎机)",
  wl_livecasino: "输赢(真人娱乐)",
  to_cockfight: "流水(斗鸡)",
  wl_others: "输赢(其他)",
  pct_sports: "百分比(体育博彩)",
  pct_slots: "百分比(老虎机)",
  pct_livecasino: "百分比(真人娱乐)",
  pct_cockfight: "百分比(斗鸡)",
  pct_others: "百分比(其他)",
  earning_sports: "收益(体育博彩)",
  earning_slots: "收益(老虎机)",
  earning_livecasino: "收益(真人娱乐)",
  earning_cockfight: "收益(斗鸡)",
  earning_others: "收益(其他)",
  cost_deposit_bonus: "存款奖金花费",
  cost_sports: "花费(体育博彩)",
  cost_slots: "花费(老虎机)",
  cost_livecasino: "花费(真人娱乐)",
  cost_cockfight: "花费(斗鸡)",
  cost_others: "花费(其他)",
  review_affiliate_ticket: "审查联盟工单",
  audit_affiliate_ticket: "审核联盟工单",
  turnover_downline: "流水(下线)",
  valid_turnover_downline: "有效流水(下线)",
  winlose_downline: "输赢(下线)",
  bet_count_downline: "投注次数(下线)",
  turnover_member: "流水(会员)",
  valid_turnover_member: "有效流水(会员)",
  winlose_member: "输赢(会员)",
  bet_count_member: "投注次数(会员)",
  dashboard_affiliate: "仪表板(联盟)",
  settlement: "结算",
  total_agent: "总代理",
  top_turnover: "总流水",
  daily_deposit: "每日存款",
  bonus_count: "奖金次数",
  deposit_amount_downline: "存款金额(下线)",
  deposit_count_downline: "存款次数(下线)",
  bonus_amount_downline: "奖金金额(下线)",
  bonus_count_downline: "奖金次数(下线)",
  deposit_amount_member: "存款金额(会员)",
  deposit_count_member: "存款次数(会员)",
  bonus_amount_member: "奖金金额(会员)",
  bonus_count_member: "奖金次数(会员)",
  verified: "已验证",
  get_tac_affiliate: "获取TAC(联盟)",
  round_id: "回合ID",
  unfinish_round: "未完成的回合",
  smartico_bonus_report: "Smartico奖金报告",
  unclaimed_amount: "未领取金额",
  claimed_amount: "已领取金额",
  unclaimed_count: "未领取次数",
  claimed_count: "已领取次数",
  withdrawal_info: "出款信息",
  withdrawal_time: "出款时间",
  submit_time: "申请时间",
  deposit_time: " 到账时间",
  player_funds: "玩家资金",
  funds_list: "资金列表",
  pending_funds: "待处理资金",
  daifu_list_auto_withdrawal: "代付列表（自动提款）",
  review_audit_list: "审查和审核列表",
  btn_href: "按键超链接",
  btn_text: "按键文本",
  recent_inbox_claim: "最近收件箱领取",
  raise_deposit_ticket_gateway: "提出存款票务(网关)",
  gateway_acc: "网关户口",
  provider_winlose_member: "供应商输赢(会员)",
  review_by: "审查者",
  daifu_list_auto_withdrawal_export: "代付列表导出（自动提款）",
  retention: "保留",
  current_month_active_user: "当月活跃用户",
  current_month_active: "当月活跃",
  first_month: "第一个月",
  fmwinlose: "第一个月赢输",
  fmdeposit_amount: "第一个月存款金额",
  cohort: "队列",
  promotion_withdrawal_summary: "促销提款总结",
  unique_player: "独特的玩家",
  year: "年份",
  audit_time_modified: "审核时间",
  audit_time_created: "审核时间",
  approve_time: "批准时间",
  unique_login_count: "独特登录次数",
  unique_withdrawal_count: "独特出款次数",
  second_deposit_count: "第二次存款次数",
  unique_login: "独特登录",
  unique_withdrawal: "独特出款",
  second_deposit: "第二次存款",
  audit_list: "审核列表",
  rollback_count: "回滚次数",
  rejected_ticket_id: "已拒绝工单ID",
  rollback: "回滚",
  recipient_bank_acc_holder: "收款银行帐户持有人",
  reject_date: "拒绝日期",
  processing_date: "处理日期",
  manual_approve: "批准（手动）",
  pending_review_funds: "待处理和审查资金",
  table_id: "桌子ID",
  member_label: "会员标签",
  label_name: "标签名称",
  label: "标签",
  available_label: "可用标签",
  bank_default_sender: "银行默认发件",
  amount_limit: "金额限额",
  bank_type: "银行类型",
  bank_desc: "银行描述",
  iframe: "内嵌框架",
  iframe_url: "内嵌框架网址",
  exchange_rate: "汇率",
  rate: "汇率",
  rate_php: "PHP汇率",
  ticket_withdrawal_rollback: "提款工单回滚",
  smartico_bonus_report_expired: "Smartico奖金报告(已过期)",
  add_balance: "加分",
  deduct_balance: "减分",

  reward_type: "奖励类型",
  turnover_rebate: "流水回扣",
  turnover_rebate_1: "VIP层数",
  turnover_rebate_2: "流水层数",
  vip_cycle_day: "VIP周期日",
  vip_maintain_deposit: "VIP保持存款",
  vip_maintain_turnover: "VIP保持流水",
  is_addon: "添加",
  no_reward: "没有奖励",
  cash: "现金",
  cs: "客户服务",
  social_platform: "社交平台",
  edit_vip: "编辑VIP",
  edit_vip_provider: "编辑VIP供应商",
  turnover_tier: "流水层数",
  rebate_rate: "回扣率",
  edit_turnover_tier: "编辑流水层数",
  delete_turnover_tier: "删除流水层数",
  vip_provider_rebate_batch: "VIP供应商批量回扣",
  srr: "自回扣率",
  drr: "下线回扣率",
  vip_log: "VIP日志",
  member_full_record: "会员完整记录",
  level: "等级 | 等级",
  before: "前",
  after: "后",
  maintain: "保持",
  actual_rebate: "实际回扣",
  rounded_rebate: "四舍五入回扣",
  rebate_list: "回扣列表",
  rebate_mode: "回扣模式",
  inbox_id: "收件箱ID",
  rebate_type: "回扣类型",
  rebate_list_member: "回扣列表(会员)",
  promotion_type: "促销类型",
  bonus_rate_1: "比率1",
  bonus_rate_2: "比率2",
  bonus_rate_3: "比率3",
  bonus_rate_4: "比率4",
  bonus_rate_5: "比率5",
  bonus_rate_6: "比率6",
  bonus_rate_7: "比率7",
  bonus_rate_8: "比率8",
  bonus_rate_9: "比率9",
  bonus_rate_10: "比率10",
  delete_all: "全部删除",
  rescue_fund: "救援基金",
  up: "上",
  down: "下",
  rate_percent: "比率%",
  rescue_fund_payout: "救助基金支付",
  cycle: "周期",
  actual_amount: "实际金额",
  rounded_amount: "四舍五入金额",
  payout_list: "支付列表",
  rescue_id: "救援ID",
  rescue_name: "救援名称",
  rescue_cycle: "救援周期",
  min_lose: "最小损失",
  rescue_rate: "救援比率",
  max_payout: "最大支付",
  payout_method: "支付方式",
  target_group: "目标组",
  member_vip_id: "会员VIP ID",
  member_vip_name: "会员VIP名称",
  member_vip_level: "会员VIP等级",
  rescue_vip_id: "救援VIP ID",
  rescue_vip_name: "救援VIP名称",
  rescue_vip_level: "救援VIP等级",
  daily: "每日",
  weekly: "每周",
  monthly: "每月",
  current_level: "当前等级",
  next_level: "下个等级",
  rescue: "救援",
  bet_value: "投注值",
  line_bet: "线注",
  total_round: "总回合",
  audit_by: "审核者",
  possible_next_level: "下个可能等级",
  maintain_deposit: "保持存款",
  maintain_turnover: "保持流水",
  starting_deposit: "初始存款",
  starting_turnover: "初始流水",
  cycle_deposit: "周期存款",
  cycle_turnover: "周期流水",
  vip_list: "VIP列表",
  up_maintain: "向上维护",
  down_lowest: "降到最低",
  manual: "手动",
  daily_winlose_game: "每日输赢(游戏)",
  action_affiliate: "操作(联盟)",
  game_name_exclude: "排除游戏",
  add_game_exclude: "添加排除游戏",
  log_repulling: "日志重拉",
  one_api: "ONE Api",
  update_global_setting: "更新全局设置",
  update_status: "更新状态",
};
